import { api } from "shared/api";

export const useHasDeferredIncomes = (companySlugOrId: string) => {
  const deferredIncomeExists = api.deferredIncome.useDeferredIncomeExists(companySlugOrId);

  return deferredIncomeExists.data?._exists;
};
